// USD → GYD conversion (Guyanese Dollar).
// 1 USD = 200 GYD. Static rate — real rate is ~209 GYD/USD, but the
// creator/user asked us to display the round conversion.
export const USD_TO_GYD = 200;

/**
 * Format a USD amount as its GYD equivalent, e.g. 10.60 → "2,120 GYD".
 * Rounds to nearest whole GYD.
 */
export function formatGyd(usdAmount) {
  const usd = Number(usdAmount) || 0;
  const gyd = Math.round(usd * USD_TO_GYD);
  return `${gyd.toLocaleString()} GYD`;
}
